module.exports = __webpack_public_path__ + "static/media/receipt.ff2ca6d5.png";